import { useMemo } from "react";
import { graphql, useStaticQuery } from "gatsby";
import sortBy from "lodash/sortBy";

interface TeamMembersData {
  members: {
    edges: SbContentNode[];
  };
}

/**
 * Build-time member list used by the Person JSON-LD nodes. Mirrors the query
 * and ordering in OurTeamSection, but is kept separate so the schema does not
 * depend on that section being rendered.
 */
export function useTeamMembers(): MemberType[] {
  const teamData = useStaticQuery<TeamMembersData>(graphql`
    query StructuredDataMembersQuery {
      members: allStoryblokEntry(
        filter: { field_component: { eq: "data_teamMember" } }
      ) {
        edges {
          node {
            content
            uuid
            slug
          }
        }
      }
    }
  `);

  return useMemo(() => {
    const members: MemberType[] = (teamData?.members?.edges || []).map(
      ({ node }) => ({
        ...(JSON.parse(node.content) as MemberType),
        uuid: node.uuid,
        slug: node.slug,
      })
    );

    return sortBy(members, (el) => (el.order ? parseInt(el.order, 10) : null));
  }, [teamData]);
}
